import { ItemList } from '../orm'


class PhotographList extends ItemList {
  getEntityKey() {
    return 'customer/photograph'
  }

}

class PhotographDeleteList extends ItemList {
  getEntityKey() {
    return 'customer/photograph/make_unavailable_to_purchase'
  }

  makeUnavailable({ photograph_ref }) {
    return this.saveNewObject({
      photograph_ref: photograph_ref,
    })
  }
}

export const basePhotographList = new PhotographList('base_photograph_match_default')
export const photographList = new PhotographList('probable_photograph_match_default')
export const possiblePhotographMatchList = new PhotographList('possible_photograph_match_default')
export const photographDeleteList = new PhotographDeleteList('photograph_delete_default')

class ExpandSearchList extends ItemList {
  getEntityKey() {
    return 'customer/photograph/expand_search'
  }

  expandSearch({ photographRefs }) {
    return this.saveNewObject({ photograph_refs: photographRefs })
  }
}

export const expandSearchList = new ExpandSearchList('expand_search_default')
